import { Card, CardBody, Col } from "reactstrap";
import { H1, H6, P } from "../../../AbstractElements";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import { GrAnnounce } from "react-icons/gr";
import translate from "translate";

const ProfileGreet = (props: any) => {
  const [MemberName, setMemberName] = useState(
    localStorage.getItem("MemberName")
  );

  useEffect(() => {
    const name = localStorage.getItem("MemberName") || "";
    translate.engine = "google"; // or "libre"
    translate(name, { from: "en", to: "hi" }).then((res) => {
      setMemberName(res);
    });
  }, []);

  return (
    <>
      <Col xl="12" sm="12" className="order-md-1 order-1">
        <div className="cta-strip">
          <p className="cta-text">
            <GrAnnounce />
            <Marquee gradient={false} speed={50} pauseOnHover={true}>
              सुकन्या स्वास्तिक केयर बायोडिग्रेडेबल सैनिटरी पैड्स और जागरूकता
              अभियानों के ज़रिए महिलाओं के स्वास्थ्य व सम्मान की दिशा में अनूठी
              पहल कर रहा है।
            </Marquee>
          </p>
          {/* <a href="tel:+918318612228" className="cta-btn">
            Call at +91 8318612228
          </a> */}
        </div>
      </Col>

      <Col xl="5" md="5" sm="12" className="order-md-2 order-2">
        <Card className="profile-greeting card-hover boxshadow overflow-hidden">
          <CardBody>
            <div className="img-overlay">
              {/* <H1>Glad You're Here!</H1> */}
              <H1>ख़ुशी है कि आप यहाँ हैं!</H1>
              <P className="mb-1">
                {MemberName} स्वागत है आपका सुकन्या स्वस्तिक केयर परिवार में!
              </P>
              <P className="f-13">
                Last Login: {localStorage.getItem("LastLoginDate")}{" "}
              </P>

              <H6 className="my-2">Profile Status</H6>
              <div className="referblock">
                <div className="socialMedia">
                  <p className="social">Paid Status</p>
                   <span className="status success">
                    {props.pdata?.PaidStatus || "N/A"}
                  </span>
                </div>
                <div className="socialMedia">
                  <p className="social">Package</p>
                   <span className="status success">
                    {props.pdata?.TotalPackageAmount || "N/A"}
                  </span>
                </div>

                {/* <div className="statusblock">
                  <p className="statustext">Paid Status</p>
                  <span className="status success">
                    {props.pdata?.PaidStatus || "N/A"}
                  </span>
                </div>
                <div className="statusblock">
                  <p className="statustext">Package</p>
                  <span className="status success">
                    {props.pdata?.TotalPackageAmount || "N/A"}
                  </span>
                </div> */}
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default ProfileGreet;
